/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Save_User_FailedInputs */



/**
* | output |
* | --- |
* | "Error saving user. {error}" |
*
* @param {Team_Manager_Save_User_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_save_user_failed = /** @type {((inputs: Team_Manager_Save_User_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Save_User_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de l’enregistrement de l’utilisateur. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Speichern des Benutzers. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante il salvataggio dell'utente. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка сохранения пользователя. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al guardar el usuario. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`保存用户时出错。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ユーザーの保存中にエラーが発生しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`उपयोगकर्ता को सहेजने में त्रुटि। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao salvar o usuário. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error saving user. ${i?.error}`)
});